import H3 from './H3';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, H3.extend`
  font-weight: 400;
  margin-bottom: ${theme.unit}px;
`);



// WEBPACK FOOTER //
// ./src/components/headings/BlockTitle.js